import { logg } from '@/util/logg';
import { GameManager } from '@lc/interface/gameManager/types';

export function getLocalKeyForGameId(gameId: number) {
	return `game_${gameId}`;
}

export function getLocalGameManagerForGameId(gameId: number) {
	const localGameKey = getLocalKeyForGameId(gameId);
	const gameManagerJSON = localStorage.getItem(localGameKey);

	if (!gameManagerJSON) {
		return null;
	}

	return JSON.parse(gameManagerJSON);
}

export async function saveGameToJSON(gameId: number, gameManager: GameManager) {
	const localKey = getLocalKeyForGameId(gameId);
	const gameString = JSON.stringify(gameManager);
	localStorage.setItem(localKey, gameString);
}

export async function getSinglePlayerGameList() {
	let tempGameList: any = [];

	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (key) {
			const value = localStorage.getItem(key);
			// logg(`${key}: ${value}`);

			if (value) {
				const tempGameObj = await JSON.parse(value);
				// logg('tempGameObj', tempGameObj);

				if (tempGameObj && tempGameObj.gameId) {
					const gameMeta = {
						game_id: tempGameObj.gameId,
					};

					// logg('tempGameList inner', tempGameList);
					tempGameList.push(gameMeta);
				} else {
					logg('tempGameObj error');
				}
			} else {
				logg('value borked?');
			}
		}
	}

	// logg('tempGameList', tempGameList);
	return tempGameList.sort((a: any, b: any) => b.game_id - a.game_id);
}
